<template>
  <el-dialog
    title="Select visibility condition"
    width="600px"
    :before-close="handleCancel"
    :visible.sync="isVisible"
    v-if="currentMatrixChoice"
  >
    <p class="help-description">
      Only display the question
      <strong>"{{ currentMatrixChoice.title }}"</strong>, once the user has selected a specific
      choice from one of the following questions.
    </p>
    <div v-for="matrixChoice in availableMatrixChoices" :key="matrixChoice.id" class="matrix-item">
      <div class="title">{{ matrixChoice.title }}</div>
      <el-radio-group size="mini" v-model="currentMatrixChoice.visibleIf">
        <span>
          <el-radio-button
            v-for="choice in matrixChoice.choices"
            :key="choice.id"
            :label="`{row.matrix${matrixChoice.id}}='${choice.title}'`"
            >{{ choice.title }}</el-radio-button
          >
        </span>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="pull-left"
        :disabled="!currentMatrixChoice"
        @click="handleRemoveLinks"
        type="danger"
        >Remove condition</el-button
      >
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleSave">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

export default {
  name: 'ConditionalLogicDialog',
  data: () => ({
    selectedChoice: null,
    selectedMatrixChoice: null,
  }),
  computed: {
    ...mapGetters('surveybuilder', ['matrixChoices']),
    ...mapState('surveybuilder', ['canvasQuestions', 'survey']),

    isVisible: {
      get() {
        return this.$store.state.surveybuilder.matrixConditionalLogicDialogVisible;
      },
      set(value) {
        this.$store.commit(
          `surveybuilder/${surveyBuilderTypes.SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY}`,
          value,
        );
      },
    },

    availableMatrixChoices() {
      return this.matrixChoices.filter(mc => mc.id !== this.currentMatrixChoice.id);
    },

    currentMatrixChoice: {
      get() {
        return (
          this.selectedMatrixChoice ||
          this.$store.state.surveybuilder.matrixConditionalLogicDialogMatrixChoice
        );
      },
      set(value) {
        this.selectedMatrixChoice = value;
      },
    },
  },
  methods: {
    handleRemoveLinks() {
      this.currentMatrixChoice.visibleIf = '';
    },
    handleCancel() {
      this.isVisible = false;
    },
    handleSave() {
      const updatedMatrixChoices = this.matrixChoices.map(mc => {
        if (mc.id !== this.currentMatrixChoice.id) {
          return mc;
        }
        return this.currentMatrixChoice;
      });

      const updatedQuestions = this.canvasQuestions.map(q => {
        if (q.questionType !== 'MEDIA') {
          return q;
        }
        return { ...q, matrixChoices: updatedMatrixChoices };
      });

      this.$store
        .dispatch('surveybuilder/updateQuestions', {
          questions: updatedQuestions,
          surveyId: this.survey.id,
        })
        .then(() => {
          this.isVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';
.help-description {
  color: darken($colony-light-gray, 35%);

  strong {
    color: black;
  }
}
.matrix-item {
  width: 100%;
  margin-bottom: 4px;
  padding: 8px;
  border-radius: 3px;
  background-color: lighten($colony-light-gray, 5%);
  cursor: grab;

  .title {
    font-size: 1.2em;
    margin-bottom: 0.4em;
  }
}
</style>



// WEBPACK FOOTER //
// MatrixConditionalLogicDialog.vue?44155826